/**
 * MobileLayout 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const MobileLayoutProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.showArrows',
        label: '화살표 표시',
        control: 'Checkbox',
        defaultValue: true
      },
      {
        name: 'componentProps.scrollAmount',
        label: '스크롤 이동량',
        control: 'NumberField',
        defaultValue: 100,
        min: 50,
        max: 500,
        step: 10
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'componentProps.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'componentProps.textColor',
        label: '텍스트 색상',
        control: 'ColorPicker',
        defaultValue: '#000000'
      },
      {
        name: 'componentProps.activeTextColor',
        label: '선택 텍스트 색상',
        control: 'ColorPicker',
        defaultValue: '#3b82f6'
      },
      {
        name: 'style.borderBottom',
        label: '하단 테두리',
        control: 'TextField',
        defaultValue: '1px solid #ccc'
      }
    ]
  },
  {
    group: '메뉴 항목',
    properties: [
      {
        name: 'componentProps.menuItems',
        label: '메뉴 항목',
        control: 'DynamicList',
        defaultValue: [
          { label: '내 정보', path: '/mydata' },
          { label: '자산정보', path: '/points' },
          { label: '추천인', path: '/recommendee' },
          { label: '계보도', path: '/legs' },
          { label: '멤버십투자', path: '/getmembership' },
          { label: '수당요약', path: '/getPaybacks' }
        ],
        itemProperties: [
          {
            name: 'label',
            label: '메뉴명',
            control: 'TextField'
          },
          {
            name: 'path',
            label: '경로',
            control: 'TextField'
          }
        ]
      }
    ]
  }
];

export default MobileLayoutProperties; 